<template>
  <!--  所有文章详情页面-->
  <div id="mainBody">
    <div id="mainBodyS">
      <breadcrumb msg="文章" msg1="正文"></breadcrumb>
      <div id="contentsOfArticle">
        <h2>{{infoData.name}}</h2>
        <h5>发布时间：{{infoData.pubdate}}</h5>
        <div v-html="infoData.drugIntroduction" class="str">
        </div>
        <div id="link" v-if="infoData.fileList.length>0">
          附件 :<a class="link" v-for="item in infoData.fileList" :key="item.id" :href="item.fileUrl">{{item.name}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import breadcrumb from "../components/breadcrumb1";
  import {drugInfoDetail} from '../../api/api.js'

  export default {
    data() {
      return {
        infoData: {
          fileList: []
        }
      }
    },
    created() {
      if (this.$route.query.id) {
        this.getInfo(this.$route.query.id)
      }
    },
    components: {breadcrumb},
    methods: {
      getInfo(id) {
        drugInfoDetail({id: id}).then(res => {
          if (res.data.code === 200) {
            this.infoData = res.data.data
            console.log(this.infoData)

          }
        })
      }
    }
  };
</script>

<style lang="less" scoped>
  #mainBodyS {
    width: 1200px;
    min-height: 550px;
    margin: 0 auto;
    padding: 40px;

    #contentsOfArticle {
      margin-top: 80px;

      .str {
        text-indent: 2rem;
        margin-top: 40px;
      }

      h2,
      h5 {
        text-align: center;
      }
    }
  }

  .link {
    color: black;
    text-decoration: none;
  }

  #link :hover {
    color: #0574A8;
    // text-decoration: underline;
  }
</style>
<style lang="less">
  #mainBody {
    background-image: url(../assets/img/jkjt3.jpg);
    background-size: 100% 100%;

    /deep/ #address {
      color: rgb(69, 109, 171);
      font-size: 15px;
      font-weight: 600;
    }

    //   /deep/ .el-breadcrumb__inner {
    //     color: #ffffff;
    //   }
    /deep/ .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      color: rgb(69, 109, 171) !important;
    }

    /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      color: rgb(69, 109, 171) !important;
      font-weight: 600 !important;
    }

    /deep/ .el-breadcrumb__separator {
      color: rgb(69, 109, 171) !important;
    }
  }
  .ql-align-right{
    text-align: right;
  }
  .ql-align-center{
    text-align: center;
  }
</style>
